<div class="header">
  <strong class="title">Modify Configuration</strong>
  @if ((config() | keyvalue)?.length > 0) {
    <fw-tooltip title="Reset to Defaults" position="right">
      <fw-icon-button size="small" test-id="reset-config-button" icon="rotate-refresh" (click)="confirmReset()"></fw-icon-button>
    </fw-tooltip>
  }
</div>
@if ((config() | keyvalue)?.length === 0) {
  <div>There are no configuration options for this gear.</div>
}
<form [formGroup]="form">
  @for (parameter of config() | keyvalue; track parameter.key) {
    <div test-id="gear-config-parameter" class="gear-config-parameter">
      <div class="gear-config-info">
        <span
          [fwTooltip]="parameter?.value?.description"
          fwTooltipPosition="left">
          {{ parameter.key }}
        </span>
      </div>
      <div class="gear-config-value">
        @if ($any(parameter.value).items?.enum) {
          <!-- Enumerated array -->
          <fw-wrapped-input [errorText]="getError(parameter.key)">
            <fw-multi-select [formControlName]="parameter.key" test-id="gear-config-field" [placeholder]="getPlaceholder(parameter.key)" width="100%">
              @for (option of $any(parameter.value).items.enum; track option) {
                <fw-menu-item [value]="toString(option)" [title]="toString(option)"></fw-menu-item>
              }
            </fw-multi-select>
          </fw-wrapped-input>
        } @else if (parameter.value?.enum) {
          <!-- Single value enum -->
          <fw-wrapped-input [errorText]="getError(parameter.key)">
            <fw-select [formControlName]="parameter.key" test-id="gear-config-field" [placeholder]="getPlaceholder(parameter.key)" width="100%">
              @for (option of parameter.value.enum; track option) {
                <fw-menu-item [value]="toString(option)" [title]="toString(option)"></fw-menu-item>
              }
            </fw-select>
          </fw-wrapped-input>
        } @else {
          @switch (parameter.value.type) {
            @case ('array') {
              <!-- Unbounded array -->
              <fw-wrapped-input [errorText]="getError(parameter.key)">
                <fw-typeahead [formControlName]="parameter.key" test-id="gear-config-field" [placeholder]="getPlaceholder(parameter.key)" ></fw-typeahead>
              </fw-wrapped-input>
            }
            @case ('boolean') {
              <fw-checkbox [formControlName]="parameter.key" test-id="gear-config-field"></fw-checkbox>
            }
            @default {
              <fw-wrapped-input [errorText]="getError(parameter.key)">
                @switch (parameter.value.type) {
                  @case ('integer') {
                    <fw-text-input test-id="gear-config-field"
                      type="number"
                      [placeholder]="getPlaceholder(parameter.key)"
                      [formControl]="$any(form.get(parameter.key))"
                    ></fw-text-input>
                  }
                  @case ('number') {
                    <fw-text-input test-id="gear-config-field"
                      type="number"
                      [formControl]="$any(form.get(parameter.key))"
                      [placeholder]="getPlaceholder(parameter.key)"
                    ></fw-text-input>
                  }
                  @default {
                    <fw-text-input test-id="gear-config-field"
                      type="text"
                      [formControl]="$any(form.get(parameter.key))"
                      [placeholder]="getPlaceholder(parameter.key)"
                    ></fw-text-input>
                  }
                }
              </fw-wrapped-input>
            }
          }
        }
      </div>
    </div>
  }
</form>
